// This file was automatically generated from appchart.dialog.order.viewLabOrderSets.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.order.viewLabOrderSets');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.order.viewLabOrderSets.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class=""><p class="el8Italic el8Gray el8AlignCenter mt10">Click an order set to add it to your order.</p><p class="el8AlignCenter"><a href="/settings/laborders/" target="_blank" rel="noopener">add/edit/delete templates</a></p><div id="view-lab-order-sets-list"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.order.viewLabOrderSets.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.orderSets.length) {
    output.append('<ul class="ordersetContainer">');
    var setList2083 = opt_data.orderSets;
    var setListLen2083 = setList2083.length;
    for (var setIndex2083 = 0; setIndex2083 < setListLen2083; setIndex2083++) {
      var setData2083 = setList2083[setIndex2083];
      output.append('<li class="order-set-item select-trigger item" data-id="', soy.$$escapeHtml(setData2083.id), '"><div class="ordersetTitle"><span class="el8BrandDark el8Bold">', soy.$$escapeHtml(setData2083.name), (setData2083.vendorDisplayName) ? ' -- Vendor: ' + soy.$$escapeHtml(setData2083.vendorDisplayName) : '', (setData2083.vendorCompendium) ? ' [' + soy.$$escapeHtml(setData2083.vendorCompendium) + ']' : '', '</span></div><div class="ordersetDetails fieldSection"><div class="cardColumn fr w40">');
      if (setData2083.icd10Codes.length) {
        output.append('<div class="el8FieldSection"><label class="el8label el8FieldMedium">ICD-10:</label><div class="el8FieldMediumLabelPadding mt3"><ol>');
        var cList2101 = setData2083.icd10Codes;
        var cListLen2101 = cList2101.length;
        for (var cIndex2101 = 0; cIndex2101 < cListLen2101; cIndex2101++) {
          var cData2101 = cList2101[cIndex2101];
          output.append('<li class="el8BulletText">', soy.$$escapeHtml(cData2101), '</li>');
        }
        output.append('</ol></div></div>');
      }
      if (setData2083.icd9Codes.length) {
        output.append('<div class="fieldSection"><label class="el8label el8FieldMedium">ICD-9:</label><div class="el8FieldMediumLabelPadding mt3"><ol>');
        var cList2110 = setData2083.icd9Codes;
        var cListLen2110 = cList2110.length;
        for (var cIndex2110 = 0; cIndex2110 < cListLen2110; cIndex2110++) {
          var cData2110 = cList2110[cIndex2110];
          output.append('<li class="el8BulletText">', soy.$$escapeHtml(cData2110), '</li>');
        }
        output.append('</ol></div></div>');
      }
      output.append('</div>');
      if (setData2083.tests) {
        output.append('<div class="cardColumn w59"><div class="fieldSection"><label class="el8label saved">Tests:</label><div class="el8FieldShortLabelPadding mt3"><ol>');
        var tList2120 = setData2083.tests;
        var tListLen2120 = tList2120.length;
        for (var tIndex2120 = 0; tIndex2120 < tListLen2120; tIndex2120++) {
          var tData2120 = tList2120[tIndex2120];
          output.append('<li class="el8BulletText">', soy.$$escapeHtml(tData2120), '</li>');
        }
        output.append('</ol></div></div></div>');
      }
      output.append('</div></li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8FeedEmpty">You have no saved order sets.</p>');
  }
  if (!opt_sb) return output.toString();
};
